module.exports = __webpack_public_path__ + "img/pantalla-2-1.e9c2aedb.png";